<template>
  <!-- start page title -->
  <div class="row">
    <div class="col-12">
      <div class="d-flex align-items-center justify-content-between">
        <h4 class="mb-0 font-size-16">{{ title }}</h4>
      </div>
    </div>
  </div>
  <!-- end page title -->
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    items: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
};
</script>
